import React from 'react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { AnnotationSetsContainer, ContentContainer, TableContainer } from './AnnotationSets.style';
import Search from './Search';
import Table from './Table';
import {
  useGetFullAnnotationSetsQuery,
  useLazyGetFullAnnotationSetQuery,
} from '../../../redux/slices/icardio';
import { IAnnotationSet, IPagination } from '../../../models/icardio';

const AnnotationSets = () => {
  const { icid: annotationSetIcid } = useParams();
  const [annotationSet, setAnnotationSet] = useState<IAnnotationSet>();

  const { data: annotationSetsResponse } = useGetFullAnnotationSetsQuery() as { data: IPagination };
  const [getFullAnnotationSet, { isLoading: annotationSetsResponseIsLoading }] =
    useLazyGetFullAnnotationSetQuery();
  const annotationSets = annotationSetsResponse?.results;

  useEffect(() => {
    if (!annotationSetIcid) return;
    getFullAnnotationSet(annotationSetIcid)?.then(response => setAnnotationSet(response.data));
  }, [annotationSetIcid, getFullAnnotationSet]);

  return (
    <AnnotationSetsContainer>
      <ContentContainer>
        <TableContainer>
          <Search annotationSets={annotationSets} setAnnotationSet={setAnnotationSet} />
          <Table
            annotationSet={annotationSet}
            annotationSetsResponseIsLoading={annotationSetsResponseIsLoading}
          />
        </TableContainer>
      </ContentContainer>
    </AnnotationSetsContainer>
  );
};

export default AnnotationSets;
